import { render, staticRenderFns } from "./user_presence.vue?vue&type=template&id=162429ea&scoped=true&"
import script from "./user_presence.vue?vue&type=script&lang=ts&"
export * from "./user_presence.vue?vue&type=script&lang=ts&"
import style0 from "./user_presence.vue?vue&type=style&index=0&id=162429ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162429ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
